'use client'

import { createContext, useContext } from 'react'

type GlassUIContextValue = {
  enableGlassUI: boolean
}

const GlassUIContext = createContext<GlassUIContextValue | null>(null)

export function GlassUIProvider({
  enableGlassUI,
  children,
}: {
  enableGlassUI: boolean
  children: React.ReactNode
}) {
  return (
    <GlassUIContext.Provider value={{ enableGlassUI }}>
      {children}
    </GlassUIContext.Provider>
  )
}

export function useGlassUI() {
  const context = useContext(GlassUIContext)

  if (!context) {
    throw new Error('useGlassUI must be used inside GlassUIProvider')
  }

  return context
}